<template>
  <div class="dataFiles-input">
    <input
      type="file"
      class="form-control-file"
      accept=".csv,.txt,.zip,.geojson,.tif,.tiff,.kmz,.kml"
      @change="onFileSelected"
      id="dataFilesInput"
    />
    <div class="progress" style="height: 2px;">
      <div class="progress-bar" id="progressBar" role="progressbar" style="width: 0%;" aria-valuemin="0" aria-valuemax="100"></div>
    </div><!-- /.progress -->
    <div
      id="fileIcons"
      v-if="$store.state.display.editMode == true"
    >
      {{ $store.state.dataset.file.originalFileName }}
    </div><!-- /#fileIcons -->
    <div
      v-if="$store.state.display.editMode == false && $store.state.dataset.file"
      id="fileIcons"
    >
      {{ $store.state.dataset.file.originalFileName }}
    </div><!-- /#fileIcons -->
  </div><!-- /.dataFiles-input -->
</template>

<script>
import { mapState } from 'vuex'
import firebase from 'firebase/compat/app'
import geoblaze from 'geoblaze'
import proj4 from 'proj4'
const epsg = require('epsg')

export default {
  data () {
    return {
      dataFilesPayload: ''
    }
  },
  props: ['farm'],
  computed: {
    ...mapState([
      'currentUser'
    ])
  },
  methods: {
    async onFileSelected (e) {
      const self = this
      self.$store.commit('setProcessingDataset', true)
      // Setup file name
      function getFormattedTime () {
        var today = new Date()
        var y = today.getFullYear()
        var m = today.getMonth() + 1
        var d = today.getDate()
        return y + '-' + m + '-' + d + '-'
      }
      function s4 () {
        return Math.floor((1 + Math.random()) * 0x10000)
          .toString(16)
          .substring(1)
      }
      const dataFilesId = getFormattedTime() + s4()
      // Get the file
      const file = e.target.files[0]
      // Get the file extension
      const lastDot = e.target.files[0].name.lastIndexOf('.')
      const fileExt = e.target.files[0].name.substring(lastDot + 1)
      // Cunstruct the path and storage reference using the farm id
      const dataFilesPath = 'datasets/' + self.farm.id + '/' + dataFilesId + '-' + file.name
      const storageRef = firebase.storage().ref(dataFilesPath)
      // The Object to be delivered
      const dataFileObject = {}

      if (fileExt === 'tif' || fileExt === 'tiff') {
        const raster = await geoblaze.load(file)
        console.log(raster)
        // if (raster.projection === 4326) {
        //   dataFileObject.xMin = raster.xmin
        //   dataFileObject.xMax = raster.xmax
        //   dataFileObject.yMin = raster.ymin
        //   dataFileObject.yMax = raster.ymax
        // } else {
        //   console.log(raster.projection)
        const firstProjection = epsg['EPSG:' + raster.projection]
        const secondProjection = epsg['EPSG:4326']
        const rasterMins = proj4(firstProjection, secondProjection, [raster.xmin, raster.ymin])
        const rasterMaxs = proj4(firstProjection, secondProjection, [raster.xmax, raster.ymax])
        console.log(rasterMins)
        console.log(rasterMaxs)
        dataFileObject.xMin = rasterMins[0]
        dataFileObject.xMax = rasterMaxs[0]
        dataFileObject.yMin = rasterMins[1]
        dataFileObject.yMax = rasterMaxs[1]
        // }
      }
      // Upload the raw file. Tag customMetadata.userId so the
      // usageFinalize backend trigger can attribute bytes to the
      // right user (see functions/usage.js).
      const task = storageRef.put(file, {
        customMetadata: {
          userId: (this.$store.state.currentUser && this.$store.state.currentUser.uid) || ''
        }
      })
      // Update the progressBar
      task.on('state_changed', function progress (snapshot) {
        const percentage = (snapshot.bytesTransferred / snapshot.totalBytes) * 100 + '%'
        document.getElementById('progressBar').style.width = percentage
      },
      function error (err) {
        console.log('errors: ' + err)
      },
      function complete () {
        // original storage info
        const dataFilePath = 'datasets/' + self.farm.id + '/' + dataFilesId + '-' + file.name
        // Set path and original file name in the storage object
        dataFileObject.path = dataFilePath
        dataFileObject.originalFileName = file.name
        // If this is already geojson, just pass the dataFilePath in, othersise
        // get the geoJson Info
        if (fileExt === 'geojson') {
          dataFileObject.geoJsonPath = dataFilePath
          self.dataFilesPayload = dataFileObject
          self.$emit('dataFilesDelivery', self.dataFilesPayload)
          document.getElementById('progressBar').style.width = 0
          self.$store.commit('setProcessingDataset', false)
        } else if (fileExt === 'tif' || fileExt === 'tiff') {
          dataFileObject.raster = true
          self.dataFilesPayload = dataFileObject
          getJpgInfo()
        } else {
          self.dataFilesPayload = dataFileObject
          getGeoJsonInfo()
        }
        // document.getElementById('progressBar').style.width = 0
      })
      function getGeoJsonInfo (attemptNumber) {
        attemptNumber = attemptNumber || 0
        // The dataSetUpload Cloud Function converts the raw file to GeoJSON
        // asynchronously; a 404 here just means it hasn't finished yet, so
        // we poll. Bounded: a conversion that never lands (e.g. a CSV with
        // no LAT/LNG columns) used to loop forever with the spinner up and
        // no message — the user's only recourse was a refresh.
        const MAX_ATTEMPTS = 100 // ≈ 5 minutes at 3 s
        const geoJsonFileName = file.name.replace(/\.[^/.]+$/, '')
        const geoJsonDataFilePath = 'datasets/' + self.farm.id + '/' + dataFilesId + '-' + geoJsonFileName + '.geojson'
        const geoJsonStorageRef = firebase.storage().ref(geoJsonDataFilePath)
        dataFileObject.geoJsonPath = geoJsonDataFilePath
        setTimeout(function () {
          geoJsonStorageRef.getDownloadURL().then(geoJsonDataFileUrl => {
            if (geoJsonDataFileUrl) {
              self.dataFilesPayload = dataFileObject
              // Deliver the goods
              self.$emit('dataFilesDelivery', self.dataFilesPayload)
              document.getElementById('progressBar').style.width = 0
            } else {
              getGeoJsonInfo(attemptNumber + 1)
            }
          }).catch(function (error) {
            if (attemptNumber + 1 >= MAX_ATTEMPTS) {
              console.log('Gave up waiting for the converted GeoJSON:', error && error.code)
              document.getElementById('progressBar').style.width = 0
              self.$store.commit('setProcessingDataset', false)
              self.$store.commit('setAlert', {
                active: true,
                message: 'The file uploaded, but it could not be converted into map data. Check that it has LAT/LNG (or Latitude/Longitude) columns and try again.',
                level: 'alert-danger',
                timeout: 15000
              })
              return
            }
            if (attemptNumber % 10 === 0) {
              console.log('Waiting for the converted GeoJSON… (attempt ' + (attemptNumber + 1) + ')')
            }
            getGeoJsonInfo(attemptNumber + 1)
          })
        }, 3000)
      }
      function getJpgInfo (attemptNumber) {
        attemptNumber = attemptNumber || 0
        // Cloud Function generates JPG from TIF; can take 30+ seconds for large rasters
        const delayMs = attemptNumber === 0 ? 8000 : Math.min(5000 + attemptNumber * 3000, 25000)
        const jpgFileName = file.name.replace(/\.[^/.]+$/, '')
        const jpgFilePath = 'datasets/' + self.farm.id + '/' + dataFilesId + '-' + jpgFileName + '.jpg'
        const jpgStorageRef = firebase.storage().ref(jpgFilePath)
        dataFileObject.jpgPath = jpgFilePath
        setTimeout(function () {
          jpgStorageRef.getDownloadURL().then(jpgFileUrl => {
            if (jpgFileUrl) {
              self.dataFilesPayload = dataFileObject
              self.$emit('dataFilesDelivery', self.dataFilesPayload)
              document.getElementById('progressBar').style.width = 0
              self.$store.commit('setProcessingDataset', false)
            } else {
              console.log('No JPG URL received, trying again')
              getJpgInfo(attemptNumber + 1)
            }
          }).catch(function (error) {
            console.log(error)
            if (error && attemptNumber < 12) {
              console.log('JPG not ready yet (attempt ' + (attemptNumber + 1) + '). Retrying in ' + (delayMs / 1000) + 's...')
              getJpgInfo(attemptNumber + 1)
            } else {
              console.log('Giving up on JPG preview after retries. Delivering without preview.')
              self.dataFilesPayload = dataFileObject
              self.$emit('dataFilesDelivery', self.dataFilesPayload)
              document.getElementById('progressBar').style.width = 0
              self.$store.commit('setProcessingDataset', false)
            }
          })
        }, delayMs)
      }
    }
  }
}
</script>
